import React, {useEffect, useState} from "react";
import styles from "./GuidePage.module.css";

export interface GuidePageStepProps {
    content?: React.ReactNode;
}

export type GuidePageProps = {
    open?: boolean;
    steps?: GuidePageStepProps[];
    onClose?: () => void;
    onGuideEnd?: () => void;
}

const GuidePage: React.FC<GuidePageProps> = props => {
    const {
        open = false,
        steps = [],
        onClose,
        onGuideEnd,
    } = props;

    if (steps.length === 0) return null;

    const [currentStep, setCurrentStep] = useState<number>(0);

    const handleClose = () => {
        onClose && onClose();
        // setCurrentStep(0);
    }

    const onNext = () => {
        setCurrentStep(currentStep+1);
    }

    const onClickNext = () => {
        setCurrentStep(currentStep+1);
    }

    useEffect(() => {
        if ((currentStep+1 > steps.length)) {
            onGuideEnd && onGuideEnd()
        }
    }, [steps,currentStep]);

    return (
        <>
            {open && (
                <div className={styles.guide_page} onClick={onClickNext}>
                    {steps.map((step, index) => {
                        return React.cloneElement(step.content as React.ReactElement, {
                            key: index,
                            currentStep,
                            currIndex: index,
                            onClick:onClickNext,
                            // onNext,
                            // onClose: handleClose,
                        })
                    })}
                </div>
            )}
        </>
    )
}

export default GuidePage;